import React, { useEffect } from 'react'

const CutSheetLables = ({ printOutPdfDetails, printRef,onRenderReady }: any) => {
    useEffect(() => {
        if (printOutPdfDetails) {
            onRenderReady?.();
        }
    }, [printOutPdfDetails]);
    return (
        <div className='row justify-content-between mt-4' id='CutSheetLables' ref={printRef}  style={{ height: "270mm", backgroundColor: "#fff", padding: "2rem", overflow: "hidden",pageBreakAfter: "always"  }}>
            <div className='col-md-6' style={{ flex: '0 0 50%', maxWidth: '50%' }} >
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map((_, index) => (
                    <div className='d-flex justify-content-center align-items-center mb-3' key={index}>
                        <div>
                            <p className='text-center fw-600 mb-0'>  {printOutPdfDetails?.primaryContactLastName}
                                {printOutPdfDetails?.secondaryContactLastName ? '/' : ''} {printOutPdfDetails?.secondaryContactLastName}</p>
                            <p className='text-center fw-600 mb-0'>Project #  {printOutPdfDetails?.projectNumber}</p>
                            <p className='text-center fw-600 mb-0'>KITCHEN</p>
                        </div>
                    </div>
                ))}
            </div>
            <div className='col-md-6' style={{ flex: '0 0 50%', maxWidth: '50%' }} >
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map((_, index) => (
                    <div className='d-flex justify-content-center align-items-center mb-3' key={index}>
                        <div>
                            <p className='text-center fw-600 mb-0'> {printOutPdfDetails?.primaryContactLastName}
                                {printOutPdfDetails?.secondaryContactLastName ? '/' : ''} {printOutPdfDetails?.secondaryContactLastName}</p>
                            <p className='text-center fw-600 mb-0'>Project #  {printOutPdfDetails?.projectNumber}</p>
                            <p className='text-center fw-600 mb-0'>BATHROOM</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default CutSheetLables